export type Country = {
  value: number;
  label: string;
  europeCountry: boolean;
  nordicCountry: boolean;
  countryId: number;
  countryCode: string;
  name: string;
};

export type Order = {
  orderId?: number;
  orderRow?: OrderRow[];
  isActive?: string;
  leader?: boolean;
  invoice?: any;
};

export type OrderRow = {
  orderId?: number;
  eventId: number;
  orderRowId: number;
  amount: number;
  vatAmount: number;
  discountAmount: number;
  sortOrder: number;
  rowTotal?: number;
  vatPercent?: number;
  status: string;
};

export enum PaymentMethod {
  Dibs = 'dibs',
  Invoice = 'invoice',
  Stripe = 'stripe',
}

export enum PaymentType {
  Comgov = 'comgov',
  Person = 'person',
}

export enum VATRegion {
  SE = 'SE',
  EU = 'EU',
}
